import styled from 'styled-components'

export const DashboardJobsFields = styled.div`
  margin-top: 12px;
  width: 100%;
`

export const DashboardJobsField = styled.div<{ isSelected?: boolean }>``
